import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Api from '../axiosConfig';
import { AuthContext } from '../context/auth.context';
import "../style/createpost.css";

const CreatePost = () => {
  const { state } = useContext(AuthContext);
  const navigate = useNavigate();
  const [postData, setPostData] = useState({ image: '', caption: '' });
  const [errors, setErrors] = useState([]);
  const [disable, setDisable] = useState(true);

  const handleChange = (event) => {
    setPostData({ ...postData, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (postData.caption && postData.image) {
        const response = await Api.post('/post/create-post', {
          postData,
          userId: state?.user?.userId,
        });
        if (response.data.success) {
          setPostData({ caption: '', image: '' });
          navigate('/home');
          toast.success(response.data.message);
        } else {
          toast.error(response.data.error);
        }
      } else {
        throw Error('All fields are mandatory.');
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Something went wrong.');
    }
  };

  useEffect(() => {
    setDisable(!(postData.caption && postData.image)); // Enable the button only if both fields are filled
  }, [postData]);

  return (
    <div className='createpostmaindiv'>
      <form onSubmit={handleSubmit}>
        <h1>Add New Post</h1>
        <div>
          <input className='createpostinput'
            type="text"
            onChange={handleChange}
            name="caption"
            value={postData.caption}
            placeholder="Caption"
          />
          <br />
        </div>
        <div>
          <input className='createpostinput'
            type="url"
            onChange={handleChange}
            name="image"
            value={postData.image}
            placeholder="Image URL"
          />
          <br />
        </div>
        {errors.length > 0 && (
          <div>
            {errors.map((error, i) => (
              <p key={i}>{error}*</p>
            ))}
          </div>
        )}
        <input className='createpostsubmit' type="submit" value="Add" disabled={disable} />
      </form>
    </div>
  );
};

export default CreatePost;
